<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Show login form if not authenticated -->
    <LoginForm v-if="!authStore.isAuthenticated" />
    
    <!-- Show admin dashboard if authenticated -->
    <div v-else>
      <!-- Header -->
      <header class="bg-white shadow-sm border-b border-gray-200">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 sm:py-0 sm:h-16 space-y-3 sm:space-y-0">
            <div class="flex items-center">
              <h1 class="text-xl sm:text-2xl font-bold text-primary-600">Панель Адміністратора</h1>
            </div>
            <div class="flex flex-col sm:flex-row items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
              <span class="text-sm sm:text-base text-gray-600">{{ authStore.user?.email }}</span>
                             <div class="flex items-center space-x-3">
                 <router-link 
                   to="/" 
                   class="text-sm sm:text-base text-gray-600 hover:text-primary-600 transition-colors duration-200 flex items-center gap-2"
                 >
                   <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                   </svg>
                   Переглянути сайт
                 </router-link>
                 <button 
                   @click="authStore.logout()"
                   class="btn-ghost flex items-center gap-2 text-sm sm:text-base"
                 >
                   <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
                   </svg>
                   Вийти
                 </button>
               </div>
            </div>
          </div>
        </div>
      </header>

      <!-- Main Content -->
      <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- Tabs -->
      <div class="mb-8">
        <nav class="flex flex-wrap gap-x-8 gap-y-2 border-b border-gray-200">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            @click="switchTab(tab.id)"
            :class="[
              'py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200',
              activeTab === tab.id
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            ]"
          >
            {{ tab.name }}
          </button>
        </nav>

      </div>

      <!-- Tab Content -->
      <div class="animate-fade-in">
        <!-- Form Builder Tab -->
        <div v-if="activeTab === 'forms'" class="space-y-6">
                                  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                          <h2 class="text-2xl font-bold text-gray-900">Конструктор Форм</h2>
                          <button 
                            @click="showCreateForm = true"
                            class="btn-hero flex items-center justify-center gap-2 w-full sm:w-auto"
                          >
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                            </svg>
                            Створити нову форму
                          </button>
                        </div>

                                  <!-- Forms List -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div 
                            v-for="form in sortedForms" 
                            :key="form.id"
                            :class="[
                              'card-modern transition-all duration-200',
                              form.is_active 
                                ? 'ring-1 ring-primary-500 bg-gradient-to-br from-primary-50 to-white shadow-lg' 
                                : 'hover:shadow-md'
                            ]"
                          >
              <div class="flex justify-between items-start">
                <div class="flex-1">
                  <div class="flex items-center space-x-3 mb-3">
                    <h3 class="text-lg font-semibold text-gray-900">{{ form.name }}</h3>
                                                                                                             <span 
                                     v-if="form.is_active"
                                     class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-sm"
                                   >
                                     <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                       <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                     </svg>
                                     Активна
                                   </span>
                  </div>
                                                  <p class="text-gray-600 mb-4">
                                  {{ form.fields.length }} поле(ів) • Створено {{ formatFormCreatedDateKyiv(form.created_at) }}
                                </p>
                  <div class="flex flex-wrap gap-2">
                                                      <button 
                                    @click="editForm(form)"
                                    class="btn-ghost flex items-center gap-2 flex-shrink-0"
                                  >
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                                    </svg>
                                    Редагувати
                                  </button>
                                  <button 
                                    v-if="!form.is_active"
                                    @click="activateForm(form.id)"
                                    class="bg-transparent text-green-600 border border-green-600 font-medium py-2 px-4 rounded-lg hover:bg-green-50 transition-colors duration-200 flex items-center gap-2 flex-shrink-0"
                                  >
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                    Активувати
                                  </button>
                                  <button 
                                    @click="deleteForm(form.id)"
                                    class="text-red-600 hover:text-red-800 transition-colors duration-200 flex items-center gap-2 flex-shrink-0 py-2 px-3 rounded-lg hover:bg-red-50"
                                  >
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                    </svg>
                                    Видалити
                                  </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Submissions Tab -->
        <div v-if="activeTab === 'submissions'" class="space-y-6">
          <div>
            <h2 class="text-2xl font-bold text-gray-900 mb-6">Відправлення Форм</h2>
            <div class="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-2 sm:gap-3">
              <div class="flex items-center gap-2 min-w-0">
                <label for="sub-date-from" class="text-xs font-medium text-gray-600 w-6 shrink-0">Від</label>
                <input
                  id="sub-date-from"
                  v-model="submissionDateFrom"
                  type="date"
                  class="min-w-0 sm:w-36 h-9 shrink-0 rounded-lg border border-gray-300 bg-white px-2.5 py-1 text-sm text-gray-900 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
              <div class="flex items-center gap-2 min-w-0">
                <label for="sub-date-to" class="text-xs font-medium text-gray-600 w-6 shrink-0">До</label>
                <input
                  id="sub-date-to"
                  v-model="submissionDateTo"
                  type="date"
                  class="min-w-0 sm:w-36 h-9 shrink-0 rounded-lg border border-gray-300 bg-white px-2.5 py-1 text-sm text-gray-900 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
              <div class="flex items-center gap-2 sm:ml-auto">
                <button
                  type="button"
                  @click="loadSubmissions()"
                  class="inline-flex h-9 items-center justify-center gap-1.5 rounded-lg border border-primary-600 bg-white px-3 text-sm font-medium text-primary-600 hover:bg-primary-50"
                >
                  <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                  </svg>
                  Оновити
                </button>
                <button
                  type="button"
                  @click="exportSubmissionsXlsx"
                  class="inline-flex h-9 items-center justify-center gap-1.5 rounded-lg bg-primary-600 px-3 text-sm font-medium text-white hover:opacity-95"
                >
                  <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  Експорт
                </button>
              </div>
            </div>
          </div>

          <!-- Submissions Table -->
          <div class="card-modern overflow-hidden">
            <div class="overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                                                      <th class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[4.75rem]">
                                    Дата
                                  </th>
                                  <th class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-[12rem] w-[12rem]">
                                    Форма
                                  </th>
                                  <th class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Дані
                                  </th>
                                  <th class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Файл
                                  </th>
                                  <th class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Статус
                                  </th>
                                  <th class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Дії
                                  </th>
                                </tr>
                              </thead>
                              <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-for="submission in formsStore.submissions" :key="submission.id">
                                  <td class="px-3 py-4 text-sm text-gray-900 align-top leading-tight tabular-nums whitespace-pre-line w-[4.75rem]">
                                    {{ formatSubmissionDateTimeKyivMultiline(submission.created_at) }}
                                  </td>
                                  <td
                                    class="px-3 py-4 min-w-0 text-sm text-gray-900 max-w-[12rem] w-[12rem] align-top break-words [overflow-wrap:anywhere] [word-break:break-word]"
                                    :title="getFormName(submission.form_id)"
                                  >
                                    <div class="leading-snug">{{ getFormName(submission.form_id) }}</div>
                                  </td>
                                  <td class="px-3 py-4 text-sm text-gray-900">
                                    <div class="max-w-xs">
                                      <div v-for="(value, key) in submission.submission" :key="key" class="mb-1 min-w-0">
                                        <span class="font-medium text-gray-700">{{ getFieldLabel(submission.form_id, key) }}:</span>
                                        <span class="text-gray-600 ml-2 inline-block max-w-full align-top break-all [overflow-wrap:anywhere]">{{ value }}</span>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <a 
                                      v-if="submission.file_link"
                                      :href="submission.file_link"
                                      target="_blank"
                                      class="text-primary-600 hover:text-primary-800 underline flex items-center gap-1"
                                    >
                                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                                      </svg>
                                      Переглянути файл
                                    </a>
                                    <span v-else class="text-gray-400">Немає файлу</span>
                                  </td>
                                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <span 
                                      :class="[
                                        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
                                        getStatusClass(submission.status)
                                      ]"
                                    >
                                      {{ getStatusText(submission.status) }}
                                    </span>
                                  </td>
                                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <div class="flex items-center space-x-2">
                                      <!-- Approve button -->
                                      <button 
                                        v-if="submission.status !== 'approved'"
                                        @click="updateSubmissionStatus(submission.id, 'approved')"
                                        class="text-green-600 hover:text-green-800 transition-colors duration-200 p-1"
                                        title="Підтвердити"
                                      >
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                      </button>
                                      
                                      <!-- Disqualify button -->
                                      <button 
                                        v-if="submission.status !== 'disqualified'"
                                        @click="updateSubmissionStatus(submission.id, 'disqualified')"
                                        class="text-red-600 hover:text-red-800 transition-colors duration-200 p-1"
                                        title="Дискваліфікувати"
                                      >
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                        </svg>
                                      </button>
                                      
                                      <!-- Delete button -->
                                      <button 
                                        @click="deleteSubmission(submission.id)"
                                        class="text-gray-600 hover:text-gray-800 transition-colors duration-200 p-1"
                                        title="Видалити відправлення"
                                      >
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                        </svg>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Site Settings Tab -->
        <div v-if="activeTab === 'settings'" class="space-y-6">
          <SiteSettingsForm />
        </div>

        <div v-if="activeTab === 'embed'" class="space-y-6">
          <EmbedOriginsForm />
        </div>
      </div>
    </main>

      <!-- Create/Edit Form Modal -->
      <FormBuilderModal 
        v-if="showCreateForm || editingForm"
        :form="editingForm"
        @close="closeFormModal"
        @save="saveForm"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useFormsStore } from '@/stores/forms'
import { useSiteSettingsStore } from '@/stores/siteSettings'
import FormBuilderModal from '@/components/admin/FormBuilderModal.vue'
import LoginForm from '@/components/admin/LoginForm.vue'
import SiteSettingsForm from '@/components/admin/SiteSettingsForm.vue'
import EmbedOriginsForm from '@/components/admin/EmbedOriginsForm.vue'
import type { Form } from '@/stores/forms'
import {
  formatFormCreatedDateKyiv,
  formatSubmissionDateTimeKyivMultiline,
  kyivDateRangeFromSubmissions,
  kyivTodayDateString
} from '@/utils/dateKyiv'
import { downloadSubmissionsXlsx } from '@/utils/submissionsExport'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const formsStore = useFormsStore()
const siteSettingsStore = useSiteSettingsStore()

// Determine active tab based on route
const getTabFromPath = (path: string) => {
  if (path === '/admin/submissions') return 'submissions'
  if (path === '/admin/settings') return 'settings'
  if (path === '/admin/embed') return 'embed'
  return 'forms'
}

const activeTab = ref(getTabFromPath(route.path))
const showCreateForm = ref(false)
const editingForm = ref<Form | null>(null)

const submissionDateFrom = ref('')
const submissionDateTo = ref('')

const loadSubmissions = async () => {
  await formsStore.fetchSubmissions({
    from: submissionDateFrom.value || undefined,
    to: submissionDateTo.value || undefined
  })
}

const exportSubmissionsXlsx = () => {
  const subs = formsStore.submissions
  const bounds = kyivDateRangeFromSubmissions(subs)
  const today = kyivTodayDateString()
  let fromPart = submissionDateFrom.value.trim()
  let toPart = submissionDateTo.value.trim()

  if (!fromPart) {
    fromPart = bounds?.from ?? (toPart || today)
  }
  if (!toPart) {
    toPart = bounds?.to ?? (fromPart || today)
  }

  const filename = `vidpravlennya_${fromPart}_${toPart}.xlsx`
  downloadSubmissionsXlsx(formsStore.forms, subs, filename)
}

// Sort forms so active form is always first
const sortedForms = computed(() => {
  return [...formsStore.forms].sort((a, b) => {
    if (a.is_active && !b.is_active) return -1
    if (!a.is_active && b.is_active) return 1
    return 0
  })
})

            const tabs = [
              { id: 'forms', name: 'Конструктор Форм' },
              { id: 'submissions', name: 'Відправлення' },
              { id: 'settings', name: 'Тексти сайту' },
              { id: 'embed', name: 'Вбудовування' }
            ]

// Function to handle tab switching
const switchTab = (tabId: string) => {
  activeTab.value = tabId
  if (tabId === 'submissions') {
    router.push('/admin/submissions')
  } else if (tabId === 'settings') {
    router.push('/admin/settings')
  } else if (tabId === 'embed') {
    router.push('/admin/embed')
  } else {
    router.push('/admin')
  }
}

// Watch for route changes to update active tab and reload submissions with filters
watch(
  () => route.path,
  async (newPath) => {
    activeTab.value = getTabFromPath(newPath)
    if (newPath === '/admin/submissions' && authStore.isAuthenticated) {
      await loadSubmissions()
    }
  }
)

watch([submissionDateFrom, submissionDateTo], async () => {
  if (activeTab.value !== 'submissions' || !authStore.isAuthenticated) return
  await loadSubmissions()
})

// Watch for authentication changes
watch(() => authStore.isAuthenticated, async (isAuthenticated) => {
  if (isAuthenticated) {
    await formsStore.fetchForms()
    await loadSubmissions()
    await siteSettingsStore.fetchSiteSettings()
  }
})

// Fetch data on mount
onMounted(async () => {
  // Initialize auth first
  await authStore.initAuth()
  
  // If user has token, verify it and fetch data
  if (authStore.isAuthenticated) {
    const isAuthenticated = await authStore.initAuthWithVerification()
    if (isAuthenticated) {
      await formsStore.fetchForms()
      await loadSubmissions()
      await siteSettingsStore.fetchSiteSettings()
    }
  }
})

// Form management
const editForm = (form: Form) => {
  editingForm.value = { ...form }
}

const closeFormModal = () => {
  showCreateForm.value = false
  editingForm.value = null
}

const saveForm = async (formData: any) => {
  if (editingForm.value) {
    await formsStore.updateForm(editingForm.value.id, formData)
  } else {
    await formsStore.createForm(formData)
  }
  closeFormModal()
}

const activateForm = async (id: number) => {
  await formsStore.activateForm(id)
}

const deleteForm = async (id: number) => {
  if (confirm('Ви впевнені, що хочете видалити цю форму?')) {
    await formsStore.deleteForm(id)
  }
}

            const getFormName = (formId: number) => {
              const form = formsStore.forms.find(f => f.id === formId)
              return form ? form.name : 'Невідома форма'
            }

            const getFieldLabel = (formId: number, fieldId: string) => {
              const form = formsStore.forms.find(f => f.id === formId)
              if (!form) return fieldId
              
              const field = form.fields.find(f => f.id === fieldId)
              return field ? field.label : fieldId
            }

            const deleteSubmission = async (id: number) => {
  if (confirm('Ви впевнені, що хочете видалити це відправлення?')) {
    const result = await formsStore.deleteSubmission(id)
    if (!result.success) {
      alert('Помилка видалення відправлення: ' + result.error)
    }
  }
}

// Status management functions
const updateSubmissionStatus = async (id: number, status: 'pending' | 'approved' | 'disqualified') => {
  const result = await formsStore.updateSubmissionStatus(id, status)
  if (!result.success) {
    alert('Помилка оновлення статусу: ' + result.error)
  }
}

const getStatusText = (status?: string) => {
  switch (status) {
    case 'approved':
      return 'Підтверджено'
    case 'disqualified':
      return 'Дискваліфіковано'
    default:
      return 'Очікує'
  }
}

const getStatusClass = (status?: string) => {
  switch (status) {
    case 'approved':
      return 'bg-green-100 text-green-800'
    case 'disqualified':
      return 'bg-red-100 text-red-800'
    default:
      return 'bg-yellow-100 text-yellow-800'
  }
}
</script>
